export const sum = (values: number[]) => values.reduce((total, value) => total + value, 0);
